<template>
	<div class="d3-temperature-thermometer">
		<svg :width="width" :height="height">
			<defs>
				<linearGradient id="gradient" gradientTransform="rotate(90)">
					<stop offset="0%" stop-color="#b2e3e6" stop-opacity="1" />
					<stop offset="60%" stop-color="#b2e3e6" stop-opacity="0"/>
				</linearGradient>
			</defs>
			<rect class="gradient" :x="0" :y="margin + scaled_value" :width="width" :height="level.height"/>
			<rect class="back" :x="thermometer.x" :y="thermometer.y" :width="thermometer.width" :height="thermometer.height" rx="10" ry="10"/>
			<g class="axis"></g>
			<rect class="front" :x="thermometer.x" :y="margin + scaled_value" :width="thermometer.width" :height="level.height" rx="10" ry="10"/>
		</svg>
	</div>
</template>

<script>
import * as d3 from '@/utils/d3'
export default {
	props: [
		'value'
	],
	data () {
		return {
			margin: 20,
			width: 0,
			height: 0,
			thermometer: {
				x: 0,
				y: 0,
				width: 20,
				height: 0
			},
			level: {
				height: 0
			}
		}
	},
	computed: {
		padded () {
			const width = Math.max(this.width - this.margin * 2, 0)
			const height = Math.max(this.height - this.margin * 2, 0)
			return { width, height }
		},
		scale () {
			return d3.scaleLinear()
				.domain([30, 42]).nice()
				.range([this.padded.height, 0])
		},
		scaled_value () {
			return this.scale(this.value)
		}
	},
	methods: {
		onResize () {
			//console.log('D3Temperature.onResize')
			this.width = Math.max(this.$el.offsetWidth, 0)
			this.height = Math.max(this.$el.offsetHeight, 0)
			this.thermometer.height = this.padded.height
			this.thermometer.x = (this.width - this.thermometer.width) / 2
			this.thermometer.y = this.margin
			this.level.height = Math.max(this.thermometer.height - this.scaled_value, 0)
			this.initialize()
		},
		initialize () {
			d3.select('.d3-temperature-thermometer .axis')
				.attr('transform', `translate(${this.margin}, ${this.margin})`)
				.call(
					d3.axisLeft()
						.scale(this.scale)
						.tickSize(-this.padded.width)
				)
		}
	},
	mounted () {
		window.addEventListener('resize', this.onResize)
		this.$root.$on('force-render-biometric-measure', this.onResize)
		this.onResize()
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.onResize)
		this.$root.$off('force-render-biometric-measure', this.onResize)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/biometric/widgets/measure/D3Temperature.vue